import { axiosInstance } from "../../../api/axiosInstance";
import { appCache } from "../../../cache/appCache";
import { Grade, GradeCreateRequest, GradeSection } from "../types";

// The backend drops empty lists from JSON (jackson non_empty) — put `sections` back.
const withSections = (grade: Grade): Grade => ({ ...grade, sections: grade.sections ?? [] });

// Grades, each with its active sections. Cached (appCache bucket "grades").
export const fetchGrades = (): Promise<Grade[]> =>
  appCache.getOrFetch("grades", () =>
    axiosInstance.get<Grade[]>("/grades").then((response) => response.data.map(withSections))
  );

export const createGrade = async (request: GradeCreateRequest): Promise<Grade> => {
  const response = await axiosInstance.post<Grade>("/grades", request);
  appCache.invalidate("grades");
  return withSections(response.data);
};

// Makes the grade's sections exactly `sectionCodes`; returns the grade's sections afterwards.
export const replaceGradeSections = async (
  gradeCode: string,
  sectionCodes: string[]
): Promise<GradeSection[]> => {
  const response = await axiosInstance.put<GradeSection[]>(
    `/grades/${encodeURIComponent(gradeCode)}/sections`,
    sectionCodes
  );
  appCache.invalidate("grades");
  return response.data ?? [];
};

export const removeGradeSection = async (gradeCode: string, sectionCode: string): Promise<void> => {
  await axiosInstance.delete(
    `/grades/${encodeURIComponent(gradeCode)}/sections/${encodeURIComponent(sectionCode)}`
  );
  appCache.invalidate("grades");
};
